<template>
  <div class="content4 content7 contentPage swiper-slide" :class="nowPage === 6 ? 'cartoon' : ''">
    <div class="animalNav" :style="{display: showNow === 0 ? 'flex' : 'none'}">
      <div class="leftTxtWrap">
        <img :src="txtImg" class="txtImg"/>
        <div class="heng"></div>
        <img :src="titleImg" class="titleImg"/>
        <div class="txtInfo">反鸟类得名于其肩胛骨和乌喙骨的连接方式与现生鸟类正好相反。迄今为止，已被研究过的热河生物群反鸟类超过30种。它们的颌骨上长着牙齿，说明头骨强壮可提供较大咬力；胸骨比例增大，叉骨是与现生鸟类相似的“Y”形。热河生物群中反鸟类体型已经发生巨大分异，小如蜂鸟，大如秃鹫。</div>
        <div class="btnWrap">
          <animalBtn 
            v-for="item in btnList" 
            :key="item.id" 
            :cnTitle='item.cnTitle' 
            :enTitle='item.enTitle'
            @click.native="changeShowAnimal(item.id)"
          ></animalBtn>
        </div>
      </div>
      <div class="rightImgWrap">
        <moveImg :imgSrc='rightAni' class="rightAni"></moveImg>
      </div>
    </div>

    <categoryAnimal 
      :animalType='fengningensisAnimal.animalType' 
      :animalTypeEn='fengningensisAnimal.animalTypeEn'
      :categoryTxt='fengningensisAnimal.categoryTxt'
      :categoryInfoImg='fengningensisAnimal.categoryInfoImg'
      :showList='fengningensisAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 1"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='cathayornithidaeAnimal.animalType' 
      :animalTypeEn='cathayornithidaeAnimal.animalTypeEn'
      :categoryTxt='cathayornithidaeAnimal.categoryTxt'
      :categoryInfoImg='cathayornithidaeAnimal.categoryInfoImg'
      :showList='cathayornithidaeAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 2"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='longipteryxAnimal.animalType' 
      :animalTypeEn='longipteryxAnimal.animalTypeEn'
      :categoryTxt='longipteryxAnimal.categoryTxt'
      :categoryInfoImg='longipteryxAnimal.categoryInfoImg'
      :showList='longipteryxAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 3"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='pengornithidaeAnimal.animalType' 
      :animalTypeEn='pengornithidaeAnimal.animalTypeEn'
      :categoryTxt='pengornithidaeAnimal.categoryTxt'
      :categoryInfoImg='pengornithidaeAnimal.categoryInfoImg'
      :showList='pengornithidaeAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 4"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='otherAnimal.animalType' 
      :animalTypeEn='otherAnimal.animalTypeEn'
      :categoryTxt='otherAnimal.categoryTxt'
      :categoryInfoImg='otherAnimal.categoryInfoImg'
      :showList='otherAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 5"
    ></categoryAnimal>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import txtImg from '@/assets/img/content7/txtImg.png'
import titleImg from '@/assets/img/content7/titleImg.png'
import rightAni from '@/assets/img/content7/rightAni.png'

import { btnList, fengningensisAnimal, cathayornithidaeAnimal, longipteryxAnimal, pengornithidaeAnimal, otherAnimal } from './data'


export default {
  mixins: [swiperMixin],
  data () {
    return {
      txtImg,
      titleImg,
      rightAni,
      showNow: 0, // 当前展示的是第几个
      btnList,
      fengningensisAnimal, // 丰宁原羽鸟
      cathayornithidaeAnimal, // 华夏鸟科
      longipteryxAnimal, // 长翼鸟
      pengornithidaeAnimal, // 鹏鸟科
      otherAnimal, // 其他反鸟类
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
  watch: {
    nowPage ( nowPage ) {
      if ( nowPage === 6 && this.showNow > 0 ) {
        this.showNow = 0
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import '../content4/content4.styl'
@import './content7.styl'
</style>